import "../styles/globals.css";
import "../styles/PronAnalysisSection.css";
import "../styles/interviews/Review_NavBar.css";
import "../styles/interviews/Review_Panel_AntiCheat.css";
import "../styles/interviews/Review_Panel_Assessment.css";
import "../styles/interviews/Review_Panel_Performance.css";
import "../styles/interviews/Review_Panel_PronAssess.css";
import "../styles/interviews/Review_Panel_TalkPoints.css";
import "video.js/dist/video-js.css";
import "../styles/candidates/HSLabel.css";
import "../styles/interviews/Review_Panel_Video.css";
import "../styles/interviews/TalkingPointsSection.css";
import "../styles/interviews/main.css";
import "../styles/login.css";

import { NextPage, NextComponentType, NextPageContext } from "next";

import Head from "next/head";
import { AppProps } from "next/app";
import { AuthProvider } from "@/hooks/useAuth";
// import { TablaProvider } from "@/lib/Tabla";

type NextPageWithLayout<P = {}, IP = P> = NextPage<P, IP> & {
  needAuth: boolean;
};

export type NextComponentWithLayout = NextComponentType<
  NextPageContext,
  any,
  {}
> &
  Partial<NextPageWithLayout>;

type ExtendedAppProps<P = {}> = AppProps<P> & {
  Component: NextComponentWithLayout;
  pageProps: any;
};

function MyApp({ Component, pageProps }: ExtendedAppProps) {
  const { needAuth } = Component;
  return needAuth === false ? (
    <AuthProvider disablePreAuth={true}>
      {/* <TablaProvider> */}
        <Head>
          <title> Dashboard | Sino Group | powered by Career Hackers</title>
        </Head>
        <Component {...pageProps} />
      {/* </TablaProvider> */}
    </AuthProvider>
  ) : (
    <AuthProvider disablePreAuth={false}>
      {/* <TablaProvider> */}
        <Head>
          <title> Dashboard | Sino Group | powered by Career Hackers</title>
        </Head>
        <Component {...pageProps} />
      {/* </TablaProvider> */}
    </AuthProvider>
  );
}

export default MyApp;
